// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".danger-icon svg[data-v-255ab3c2] {\n  font-size: 80px;\n}\n.debug-block h4[data-v-255ab3c2] {\n  font-size: 13px;\n  font-weight: bold;\n}\n.debug-block p[data-v-255ab3c2], .debug-block div[data-v-255ab3c2] {\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
